export const getLastLevel = (arr) => {
  let result = []
  for (const i of arr) {
    if (i.children && i.children.length) {
      result = [...result, ...getLastLevel(i.children)]
    } else {
      if (!i.hideColumnHandle) {
        result.push(i)
      }
    }
  }
  return result
}
export const getChildren = (arr, checkList, tmp) => {
  return arr.reduce((total, i) => {
    if (i.children && i.children.length) {
      const children = getChildren(i.children, checkList, tmp)
      if (children.length !== 0) {
        return [...total, { ...i, children }]
      }
    } else {
      if (checkList.includes(i.label) || i.hideColumnHandle) {
        if ('minWidth' in i) {
          tmp.hasMinWidth = true
        }
        return [...total, { ...i }]
      }
    }
    return total
  }, [])
}
export const getHandleColumns = (origin, checkList) => {
  const tmp = {}
  const result = getChildren(origin, checkList, tmp)
  if (!tmp.hasMinWidth) {
    return setMinWidth(result)
  }
  return result
}
export const setMinWidth = (result) => {
  return result.reduce((arr, i) => {
    if (i.children && i.children.length) {
      const children = setMinWidth(i.children)
      if (children.length !== 0) {
        return [...arr, { ...i, children }]
      }
    }
    const {
      width,
      ...other
    } = i
    const item = Object.assign({}, other, width ? { minWidth: width } : {})
    return [...arr, item]
  }, [])
}

export const isPlainObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]'
